import { AnimatePresence, motion } from 'motion/react';
import { useMatch } from 'react-router-dom';

import AccountDrawer from '@/components/app-shell/AccountDrawer';
import ShellGreeting from '@/components/app-shell/ShellGreeting';
import { PageHeader } from '@/components/shared/PageHeader';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { Avatar } from '@/components/ui/custom/dataDisplay/Avatar';
import { useAppShell } from '@/data/context/AppShellContext';
import useShellGoBack from '@/data/hook/app-shell/useShellGoBack';
import { swapHorizontal } from '@/utils/animations/commom';
import { ROUTES } from '@/utils/routes';

export default function ShellMobileHeader() {
  const { user } = useAppShell();
  const goBack = useShellGoBack();
  const isHome = !!useMatch({ path: ROUTES.DASHBOARD.BASE, end: true });

  return (
    <div
      data-testid="shellMobileHeader"
      className="flex min-h-16 items-center justify-between gap-4 py-1 lg:hidden"
    >
      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          key={isHome ? 'title' : 'back'}
          {...swapHorizontal}
          className="min-w-0"
        >
          <ConditionalRenderer
            condition={isHome}
            fallback={<PageHeader.Back onClick={goBack} />}
          >
            <h1 className="min-w-0 truncate text-xl font-semibold text-base-content">
              <ShellGreeting />
            </h1>
          </ConditionalRenderer>
        </motion.div>
      </AnimatePresence>
      <AccountDrawer className="rounded-full">
        <Avatar userId={user.id} size="10" />
      </AccountDrawer>
    </div>
  );
}
